export default __webpack_public_path__ + "static/media/tap-pay.1047c43f.svg";